import { Component, Inject, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DialogActions } from 'src/app/components/dialogs/dialog.model';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { InventoryService } from 'src/app/services/inventory.service';
import { Cmyk, ColorPickerService } from 'ngx-color-picker';
@Component({
  selector: 'app-create-tag-dialog',
  templateUrl: './create-tag-dialog.component.html',
  styleUrls: ['./create-tag-dialog.component.scss']
})

export class CreateTagDialogComponent implements OnInit, OnDestroy {
  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    colorCode: new FormControl('', [Validators.required]),
    tag: new FormControl(''),
  });
  actions: DialogActions[] = [];
  private destroy$ = new Subject<void>();
  spin: boolean = false;
  color:string;
  itemID: number;
  selectedTag: any;

  constructor(
    private dialogRef: MatDialogRef<CreateTagDialogComponent>,
    private snackBar: MatSnackBar,
    public vcRef: ViewContainerRef, private cpService: ColorPickerService,
    private inventoryService: InventoryService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (this.data?.tag) {
      this.itemID=this.data?.itemID;
      this.form.patchValue(this.data?.tag);
      this.color = this.data?.tag?.colorCode;
    }
  }

  action(e) {
    if (e === 'Save') {
      this.save();
    } else {
      this.close();
    }
  }

  save() {
    this.addUpdateTag();
  }

  addUpdateTag() {
    this.spin = true;
    let payload: any = {
      name: this.form.value.name,
      colorCode: this.form.value.colorCode
    }
    if (this.data?.tag) {
      payload.tagId = this.data?.tag?.tagId
    }
      this.inventoryService.AddUpdateTag(payload)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: 'Tags create successfully',
                action: 'Dismiss',
                type: 'success',
              },
            });
          this.dialogRef.close("save");
        },
       error: (err) => {
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error,
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
     });
  }

  AddTagsInProduct() {
    this.spin = true;
    let payload = {
      itemID: this.itemID,
      tagId: [this.selectedTag]
    }
      this.inventoryService
      .AddTagsInProduct(payload)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: 'Tags create successfully',
                action: 'Dismiss',
                type: 'success',
              },
            });
          this.dialogRef.close("save");
        },
       error: (err) => {
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error,
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
     });
  }

  addTagsInSku() {
    this.spin = true;
    let payload = {
      accountSkuId: this.data.accountSkuId,
      tagId: [this.selectedTag]
    }
      this.inventoryService
      .AddTagsInSku(payload)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: 'Tags create successfully',
                action: 'Dismiss',
                type: 'success',
              },
            });
          this.dialogRef.close("save");
        },
       error: (err) => {
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error,
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
     });
  }

  close() {
    this.dialogRef.close();
  }

  public onEventLog(event: string, data: any): void {
    if(data?.color){
      this.color = data.color;
      this.form.controls['colorCode'].setValue(data?.color);
    }
  }

  public onChangeColorCmyk(color: string): Cmyk {
    const hsva = this.cpService.stringToHsva(color);
    if (hsva) {
      const rgba = this.cpService.hsvaToRgba(hsva);
      return this.cpService.rgbaToCmyk(rgba);
    }
    return new Cmyk(0, 0, 0, 0);
  }

  public onChangeColorHex8(color: string): string {
    const hsva = this.cpService.stringToHsva(color, true);
    if (hsva) {
      return this.cpService.outputFormat(hsva, 'rgba', null);
    }
    return '';
  }

  openTags(e) {
    this.selectedTag = e.tagId;
    this.data.tag.forEach((ele) => {
      if (ele.tagId == e.tagId) {
        this.form.controls['name'].setValue(ele.name);
        this.form.controls['colorCode'].setValue(ele.colorCode)
      }
    })
    if(this.data?.isProductTag){
      this.AddTagsInProduct();
    } else if(this.data?.isSkuTag){
      this.addTagsInSku();
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
